import axios from 'axios';

const withCredentialsConfig = { withCredentials: true };

export const getJobResults = async (jobId) => {
  const response = await axios.get(`/api/photos/job/${jobId}`, withCredentialsConfig);
  return response.data;
};

export const updatePhotoMetadata = (jobId, photoId, payload) =>
  axios.patch(`/api/photos/job/${jobId}/photo/${photoId}`, payload, withCredentialsConfig);

export const applyPhotoMetadata = (jobId, photoId) =>
  axios.post(
    '/api/photos/apply-single',
    { jobId, photoId },
    withCredentialsConfig
  );

export const undoPhotoMetadata = (jobId, photoId) =>
  axios.post(
    '/api/photos/undo-apply',
    { jobId, photoId },
    withCredentialsConfig
  );

export const applyBatchMetadata = async (jobId, photoIds) => {
  const response = await axios.post(
    '/api/photos/apply-batch',
    { jobId, photoIds },
    withCredentialsConfig
  );
  return response.data;
};
